import React from "react";
import useIsMobile from "../hooks/useIsMobile";
import WarehousesMobile from "../mobile/admin/WarehousesMobile";
import GestionMagasin from "./GestionMagasin";

export default function ResponsiveGestionMagasin(props) {
  return useIsMobile() ? <WarehousesMobile {...props} /> : <GestionMagasin {...props} />;
}
